const APP_NAME = "GAMEOO Backoffice";

/**
 * Utility function to set the page title dynamically.
 * @param {string} title - The specific title for the page.
 */

export const usePageTitle = (title?: string) => {
  if (title) document.title = `${APP_NAME} - ${title}`;
  else document.title = APP_NAME;
};
